import ExchangeMainComponent from './ExchangeMainComponent';

export default ExchangeMainComponent;
